import { axiosKK } from '../services/networkRequest';
import FileDownload from 'js-file-download';

export const downloadOrderLabels = async (orderId: number): Promise<void> => {
  const response = await axiosKK.get(`/order/${orderId}/labels`, {
    responseType: 'blob',
  });
  FileDownload(response.data, `order-${orderId}-labels.pdf`);
};

export const downloadBoxLabel = async (orderId: number, boxId: number): Promise<void> => {
  const response = await axiosKK.get(`/order/${orderId}/labels/box/${boxId}`, {
    responseType: 'blob',
  });
  FileDownload(response.data, `order-${orderId}-box-${boxId}-label.pdf`);
};

